//src/components/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "wouter";

export default function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    // გამოვრთოთ ბრაუზერის scrollRestoration, რომ history-დან არ აღადგინოს ძველი პოზიცია
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    // თუ window-ზე ხდება scroll:
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    // თუ გაქვს შიდა scroll კონტეინერი Layout-ში:
    // const el = document.getElementById("app-scroll");
    // el?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location]);

  return null;
}
